export enum RegionPaymentCurrency {
  /** 0: 其他 */
  Other,
  /** 1: 台灣 TWD(TapPay) */
  Taiwan,
  /** @deprecated 2: 香港 HKD(Braintree) (已無使用) */
  HongKongBrainTree,
  /** 3: 馬來西亞 MYR(TapPay) */
  MalaysiaTapPay,
  /** 4: 香港 HKD(Stripe) */
  HongKong,
  /** 5: 日本 JPY(Stripe) */
  Japan,
  /** 6: 泰國 THB(Stripe) */
  Thailand,
  /** 7: 馬來西亞 MYR(Stripe) */
  MalaysiaStripe,
  /** 9: 無 */
  None,
}

export enum PaymentCurrency {
  TWD = 'TWD',
  HKD = 'HKD',
  MYR = 'MYR',
  JPY = 'JPY',
  THB = 'THB',
}
